import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as state from '../../../../../../../../state'
import * as modals from '../../../modals'

/** Displays lab assignments for a Lab Service space record */
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.table.Component,
    ds.overlay.confirmation.Component,
    modals.assignLabsToLabService.Component,
  ],
  selector: 'atn-space-lab-assignments',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** When true, the component is in read-only mode (e.g. room signed off). */
  public readonly isReadonlySg = ngCore.input(false, { alias: 'readonly' })

  /** @see {@link state.space.full.recordLabAssignments.Collection} */
  public readonly recordLabAssignmentsEc = ngCore.inject(
    state.space.full.recordLabAssignments.Collection,
  )

  /** Canonical table input for laboratories assigned to the record. */
  public readonly tableConfig = ngCore.computed(
    (isReadonly = this.isReadonlySg()) =>
      ({
        collection: this.recordLabAssignmentsEc,
        view: {
          creation: isReadonly ? false : this.addLabClickHandler,
          showColumnSettings: false,
          title: 'Laboratories',
        },
      }) satisfies ds.table.ec.Config.Input<state.space.full.recordLabAssignments.TypeParams>,
  )

  /** Opens the add-laboratories modal */
  public readonly addLabClickHandler = () => {
    this.recordLabAssignmentsEc.plugins.editingPlugin.feature.actions.edit
      .from('LabAssignments.Add.Clicked')
      .dispatch({
        id: ec.plugins.standard.editing.models.CreationId.generate(),
      })
  }

  /** Handles confirmation of removing a lab from the lab service. */
  public confirmDeletionClickHandler(): void {
    this.recordLabAssignmentsEc.plugins.editingPlugin.feature.actions.submit
      .from('LabAssignments.Delete.Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /** Handles cancellation of removing a lab from the lab service. */
  public cancelDeletionClickHandler(): void {
    this.recordLabAssignmentsEc.plugins.editingPlugin.feature.actions.discard
      .from('LabAssignments.Delete.Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
